/**
 * Axios instance untuk API publik (tanpa auth)
 * Path: /api/public/* - terpisah dari API biasa, tidak ada auth sama sekali
 */
import axios from "axios";
import { API_ESA_OFFICE } from "./index";

const apiPublic = axios.create({
  baseURL: API_ESA_OFFICE + "public/",
  timeout: 30000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Tidak ada request interceptor - tidak pernah tambahkan token
// Tidak ada response interceptor - tidak retry/refresh saat 401

export default apiPublic;
